import { Controller } from 'react-hook-form';

import { AutoCompleteDistrict } from './AutoCompleteDistrict';

export default function InputDistrict({ form, onCommit }) {
  const { control, formState } = form;
  const { errors } = formState;
  return (
    <Controller
      name="district"
      control={control}
      render={({ field }) => (
        <AutoCompleteDistrict
          name="district"
          placeholder="ตำบล/แขวง"
          onCommit={onCommit}
          error={!!errors?.district}
          {...field}
        />
      )}
    />
  );
}
